<template>
  <div id="app">
    <img class="customer-icon" src="@/assets/images/customer.gif" alt="" @click="toLink">
    <keep-alive :include="cachedViews">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import { openActivityH5 } from "@/utils/index";
export default {
  name: 'App',
  data(){
    return {
      cachedViews: ['comSchoolList', 'midSchoolList','comtownList','townSchoolList'], // 需要缓存的页面组件名称
    }
  },
  mounted() {
    setTimeout(()=>{
      this.initCnzzTracking("入口页");
    },100)
  },
  watch:{
    "$route.fullPath":{
      handler(val){
        setTimeout(()=>{
          //省宣统计代码
          if(process.env.NODE_ENV === "production"){
            let path = "http://z.timedg.com/2023/dgrb-zkt-code/H5/#" + val
            const id = this.$md5(path)
            openActivityH5(id,path)
          }
          //友盟统计代码
          const titleContains = document.title.includes("东莞市义务教育招生掌上通") || document.title.includes("东莞市中考招生手册");
          const apiUrlCorrect = process.env.VUE_APP_BASE_API_URL === "https://pub.timedg.com";
          const flag = titleContains && apiUrlCorrect
          flag && (this.initCnzzTracking(document.title))
          //报社内部统计代码
          if (window.timestatloader && window.timestatloader.stat) {
            window.timestatloader.stat.collectEvent("招考通H5访问pv", {
              idx: document.title+"访问",
            });
          }else{
            console.log("window.timestatloader加载错误",window.timestatloader)
          }
        },400)
      },
      deep:true
    },
  },
  methods: {
    toLink(){
      const href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbde327fc101333e7&redirect_uri=http%3A%2F%2F12345.dg.cn%2F12345_weixinweb%2FkfNew.do&response_type=code&scope=snsapi_base&state=#wechat_redirect'
      window.location.href = href;
    },
    //在首页共同点和中考阶段的首页和义务阶段首页埋点
    initCnzzTracking(title) {
      var date = this.$route.query.year;
      var _czc = window._czc || [];
      _czc.push(["_setAccount", "1279551605"]); // 使用您的siteid替换这里的数字
      _czc.push(["_trackEvent", "招考通h5",title!=="入口页"?date+title:title ,"新版"]);
    }
  }
}
</script>
<style lang="scss" scoped>
.customer-icon {
  position: fixed;
  bottom: 80px;
  right: -50px;
  width: 220px;
  height: auto;
  z-index: 999;
  cursor: pointer;
}
</style>

